import { useCallback, useState } from 'react';
import type { UseFormSetValue } from 'react-hook-form';
import { createBrandRows } from './client-dialog-form';
import type { BrandRow } from './client-dialog-form';
import type { ClientFormValues } from './client-form-schema';

export function useClientBrandRows(
  initialBrands: string[],
  setValue: UseFormSetValue<ClientFormValues>,
) {
  const [rows, setRows] = useState<BrandRow[]>(() => createBrandRows(initialBrands));

  function sync(nextRows: BrandRow[]) {
    setRows(nextRows);
    setValue(
      'brands',
      nextRows.map((row) => row.value),
      { shouldDirty: true, shouldTouch: true, shouldValidate: true },
    );
  }

  const reset = useCallback((brands: string[]) => setRows(createBrandRows(brands)), []);

  return {
    rows,
    reset,
    add: () => sync([...rows, { id: crypto.randomUUID(), value: '' }]),
    remove: (index: number) => sync(rows.filter((_, currentIndex) => currentIndex !== index)),
    update: (index: number, value: string) =>
      sync(rows.map((row, currentIndex) => (currentIndex === index ? { ...row, value } : row))),
  };
}
